import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import {
  cleanAuthLoading,
  clearAuthObj,
  loginIntial,
} from "../../features/auth/authSlice";
import { useEffect, useRef } from "react";
import img2 from "../../assets/img/img2.png";
import img3 from "../../assets/img/img3.png";
import Header from "./Header";
import { cleanOrgObj, clearObj } from "../../features/obj/objSlice";
import toast from "react-hot-toast";
import RightSide from "./RightSide";

export default function Login() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authLoading, isActive } = useSelector((state) => state.auth);
  const { subdomain } = useSelector((state) => state.global);
  const formRef = useRef(null);
  const onFinish = async (data) => {
    const res = await dispatch(loginIntial(data));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      await form.resetFields();
      await navigate("/login-otp");
    } else {
      toast.error(res?.payload?.messages?.message ?? "Invalid Credentials");
    }
  };

  // useEffect(() => {
  //     if (!isActive) {
  //         dispatch(logout());
  //     }
  // }, []);

  // if (isActive) {
  //     return <Navigate to="/onboarding" replace />;
  // }

  async function clean() {
    await dispatch(clearAuthObj());
    await dispatch(clearObj());
  }

  useEffect(() => {
    clean();
  }, []);

  return (
    <>
      <div className="overflow-y-scroll min-h-screen h-screen w-full">
        <div className="flex w-full  min-h-screen bg-white ">
          <div className="flex flex-col w-full ">
            <Header />
            <div className="w-full h-full flex justify-center items-center">
              <div className="w-full max-w-[32.25rem] flex flex-col lg:px-0 px-3">
                <span
                  className={`heading_1 ${
                    subdomain === "ndovupay" || subdomain === "localhost"
                      ? "!text-[#DB2A12]"
                      : "text-inherit"
                  }`}
                >
                  Login
                </span>
                <span className="paragraph_1 mt-[1.13rem]">
                  Welcome. Please fill in your details below.
                </span>

                <Form
                  layout="vertical"
                  ref={formRef}
                  name="control-ref"
                  onFinish={onFinish}
                  style={{
                    maxWidth: "100%",
                    marginTop: "2.06rem",
                    width: "32.25rem",
                  }}
                  form={form}
                >
                  <Form.Item
                    name="userEmail"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Email is required to login",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email address",
                      },
                    ]}
                  >
                    <Input type="email" className="input" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your password",
                      },
                    ]}
                  >
                    <Input.Password className="input" />
                  </Form.Item>

                  <div className="flex justify-end mt-[.5rem]">
                    <Link to="/forgot-password" className="label_2 underline">
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="w-full flex flex-col">
                    <div className="flex   mt-[1.63rem]">
                      <button
                        className="cstm-btn-2 !bg-[#000000]"
                        type="submit"
                        disabled={authLoading ? true : false}
                      >
                        {authLoading ? <Spin /> : "Sign In"}
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <RightSide />
        </div>
      </div>
    </>
  );
}
